'use strict';
angular.module('schoolLinqApp').factory('caSpecificService', [
	'$http',
	'$q',
	function ($http, $q) {
		var endpoint = '/api/caSpecific';

		function getNumberOfTemplates(search) {
			return $http.get(endpoint + '/numberOfTemplates', {
				params: { search: search },
			});
		}

		function getTemplatesByPage(search, pageSize, startIndex) {
			return $http.get(endpoint + '/getTemplatesByPage', {
				params: { search: search, pageSize: pageSize, startIndex: startIndex },
			});
		}

		function getPageIndexForTemplate(search, pageSize, startIndex, templateId) {
			return $http.get(endpoint + '/getPageIndexForTemplate', {
				params: {
					search: search,
					pageSize: pageSize,
					startIndex: startIndex,
					templateId: templateId,
				},
			});
		}

		function getMappingTemplates() {
			return $http.get(endpoint + '/getMappingTemplates');
		}

		function addEditTemplate(template) {
			return $http.post(endpoint + '/addEdit', template);
		}

		function deleteMappingTemplate(template) {
			return $http.post(endpoint + '/deleteTemplate', template);
		}

		function getTemplate(id) {
			return $http.get(endpoint + '/getTemplate', { params: { Id: id } });
		}

		function getNumberOfAccounts(accountTypeIds, search, excludeCAMapped) {
			let accountPaging = {
				AccountTypeIds: accountTypeIds,
				Search: search,
				ExcludeCAMapped: excludeCAMapped,
			};
			return $http.post('api/account/numberOf', accountPaging);
		}

		function getAccountsByPage(accountTypeIds, search, pageSize, startIndex, excludeCAMapped) {
			let accountPaging = {
				AccountTypeIds: accountTypeIds,
				Search: search,
				ExcludeCAMapped: excludeCAMapped,
				PageSize: pageSize,
				StartIndex: startIndex,
			};
			return $http.post('api/account/getByPage', accountPaging);
		}

		function getAccountsForSelectAndUnSelectAll(accountTypeIds, search, excludeCAMapped, selected) {
			return $http.get(endpoint + '/getAccountsForSelectAndUnSelectAll', {
				params: {
					accountTypeIds: accountTypeIds,
					search: search,
					excludeCAMapped: excludeCAMapped,
					selected: selected,
				},
			});
		}

		return {
			getNumberOfTemplates: getNumberOfTemplates,
			getTemplatesByPage: getTemplatesByPage,
			getPageIndexForTemplate: getPageIndexForTemplate,
			addEditTemplate: addEditTemplate,
			deleteMappingTemplate: deleteMappingTemplate,
			getTemplate: getTemplate,
			getNumberOfAccounts: getNumberOfAccounts,
			getAccountsByPage: getAccountsByPage,
			getAccountsForSelectAndUnSelectAll: getAccountsForSelectAndUnSelectAll,
			getMappingTemplates: getMappingTemplates,
		};
	},
]);
